/**
 * GpsActionButton Component
 * GPS detection action button with loading state
 */

import { ActionIcon, Loader, Tooltip } from '@mantine/core';
import { IconGps } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { GpsActionButtonProps } from '../RoadDisplayField.types';
import { ROAD_DISPLAY_FIELD_CONSTANTS } from '../RoadDisplayField.constants';

export function GpsActionButton({
  value,
  isDetectingGPS,
  disabled,
  onRequestGPSDetection,
}: GpsActionButtonProps) {
  const { t } = useTranslation();

  // Don't show GPS button if there's already a value or no handler provided
  if (value || !onRequestGPSDetection) {
    return null;
  }

  // Show loader when detecting
  if (isDetectingGPS) {
    return <Loader size={ROAD_DISPLAY_FIELD_CONSTANTS.ICONS.LOADER_MEDIUM} />;
  }

  return (
    <Tooltip label={t('gps.detectFromCurrentLocation')}>
      <ActionIcon
        variant="subtle"
        size={ROAD_DISPLAY_FIELD_CONSTANTS.ACTION_BUTTON.SIZE}
        onClick={onRequestGPSDetection}
        disabled={disabled}
      >
        <IconGps size={ROAD_DISPLAY_FIELD_CONSTANTS.ICONS.GPS_ACTION} />
      </ActionIcon>
    </Tooltip>
  );
}
